import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'ItemDetailsTab',
  props: {
  modelValue: {
    type: Number,
  },
  id: {
    type: Number,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
},
  emits: {
  'update:modelValue': null,
},
  setup(__props, { emit }) {

const props = __props;





const handleTabClick = (): void => {
  emit('update:modelValue', props.id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass({
      'w-full truncate border-b-2 border-dark-400 bg-dark-400 p-2': true,
      'tab-active-state': props.modelValue === props.id,
    }),
    onClick: handleTabClick
  }, _toDisplayString(props.label), 3))
}
}

})